module.exports = __webpack_public_path__ + "static/media/img-cover.b31da9a6.svg";